
import { useEffect, useState } from 'react';

interface YouTubeVideoPlayerProps {
  url: string;
  className?: string;
}

export function YouTubeVideoPlayer({ url, className }: YouTubeVideoPlayerProps) {
  const [videoId, setVideoId] = useState<string | null>(null);
  
  useEffect(() => {
    // Extract YouTube video ID from URL
    const extractVideoId = (youtubeUrl: string): string | null => {
      let videoId: string | null = null;
      
      // Handle youtube.com/watch?v= format
      if (youtubeUrl.includes('youtube.com/watch?v=')) {
        const urlParams = new URLSearchParams(youtubeUrl.split('?')[1]);
        videoId = urlParams.get('v');
      }
      // Handle youtu.be/ format
      else if (youtubeUrl.includes('youtu.be/')) {
        videoId = youtubeUrl.split('youtu.be/')[1]?.split('?')[0];
      }
      // Handle youtube.com/embed/ format
      else if (youtubeUrl.includes('youtube.com/embed/')) {
        videoId = youtubeUrl.split('youtube.com/embed/')[1]?.split('?')[0];
      }
      
      return videoId;
    };
    
    if (url) {
      setVideoId(extractVideoId(url));
    }
  }, [url]);
  
  if (!videoId) {
    return null;
  }
  
  return (
    <div className={`aspect-video w-full ${className || ''}`}>
      <iframe
        width="100%"
        height="100%"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
}
